export abstract class NotificationSenderService {
    abstract notifyError(message: string, outsideAngular?: boolean): void;
    abstract notifyInfo(message: string, outsideAngular?: boolean): void;
    abstract notifySuccess(message: string, outsideAngular?: boolean): void;
}
